import { render, staticRenderFns } from "./StatusHistory.vue?vue&type=template&id=1f527fc8&scoped=true&"
import script from "./StatusHistory.vue?vue&type=script&lang=js&"
export * from "./StatusHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f527fc8",
  null
  
)

export default component.exports